import { handleFieldChange } from "../../Utils";
import { Row, Col, Button } from 'react-bootstrap';
import { Component } from 'react';

import React from 'react';

import SyncMessage from "../../components/SyncMessage";
import FieldGroup from "../../components/FieldGroup";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import Icon from "../../components/Icon";
import API from '../../services/API';
import SelectWrap from "../../components/SelectWrap";

class AdkLinks extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            linkToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            domain: '',
            platform: '',
            links: [],
            syncData: null,
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleDomainUpdate = this.handleDomainUpdate.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.loadLinks();
    }


    loadLinks() {
        this.setState({ isLoading: true });

        API.AdkLinks.get().then(links => this.setState({ links, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, linkToUpdate: null });
    }

    handleFormSubmit(link) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            linkToUpdate: null
        });

        if(link.update) {
            const { type } = link;

            delete link.type;

            API.AdkLinks.update(type, link).then(() => this.loadLinks());
        }
        else API.AdkLinks.save(link).then(() => this.loadLinks());
    }

    handleUpdateBtnClick(link) {
        this.setState({ isShowForm: true, linkToUpdate: link });
    }

    handleRemoveBtnClick(type) {
        if (!window.confirm(`Are you sure to delete ${type}`)) return;

        this.setState({ isLoading: true });

        API.AdkLinks.remove(type).then(() => this.loadLinks());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'links')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    handleDomainUpdate() {
        const { domain, platform } = this.state;

        if (!window.confirm(`Update all "${platform}" domains to "${domain}"`)) return;

        this.setState({ isLoading: true });

        API.AdkLinks.updateDomain(this.state.domain, this.state.platform)
            .then(() => {
                this.setState({ isLoading: false });

                this.loadLinks();
            })
            .catch(() => {
                this.setState({isLoading: false})
            });
    }

    getForm() {
        if (this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                link={this.state.linkToUpdate}/>;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Links"/>
                <Row>
                    <Col lg={3}>
                        <FieldGroup
                            name="domain"
                            label="Domain:"
                            onChange={this.handleFieldChange}
                            value={this.state.domain}
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={[ 'legacy', 'desktop' ]}
                            label="Plaftorm:"
                            name="platform"
                            onChange={this.handleFieldChange}
                            value={this.state.platform}
                        />
                    </Col>
                    <Col lg={2}>
                        <div style={{ width: '1px', height: '25px'}}></div>

                        <Button bsStyle="success" type="submit" onClick={this.handleDomainUpdate}>Update</Button>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                {this.getForm()}

                <Table links={this.state.links} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick}/>
            </Container>
        );
    }
}

export default AdkLinks;


// WEBPACK FOOTER //
// ./src/scenes/AdkLinks/index.js